import {
  Award,
  BookOpen,
  ShieldCheck,
  Sparkles,
  Globe,
  Users,
} from "lucide-react";
import { whyChoose } from "@/data/siteContent";

const ICONS = { Award, BookOpen, ShieldCheck, Sparkles, Globe, Users };

export default function WhyChooseUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="section relative"
    >
      {/* Ambient texture */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.25]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 40%, rgba(212,175,55,0.12), transparent 40%), radial-gradient(circle at 80% 60%, rgba(30,64,175,0.15), transparent 45%)",
        }}
      />
      <div className="container-luxe relative">
        <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-14 items-end">
          <div className="reveal">
            <div className="text-[11px] tracking-[0.4em] uppercase text-gold-light">
              Why Choose Us · क्यों चुनें
            </div>
            <h2
              data-testid="why-title"
              className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.05] text-cream"
            >
              Guidance built on{" "}
              <span className="italic font-editorial gold-text">
                integrity
              </span>
              .
            </h2>
          </div>
          <p className="reveal text-cream-muted max-w-lg lg:ml-auto">
            Six quiet reasons seekers, families and business owners across
            three continents return to Jyotish ji, year after year.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {whyChoose.map((w, i) => {
            const Icon = ICONS[w.icon] || Sparkles;
            return (
              <div
                key={w.title}
                data-testid={`why-card-${i}`}
                className="reveal glass rounded-2xl p-8"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                <div className="w-12 h-12 rounded-full grid place-items-center gold-border">
                  <Icon className="w-5 h-5 text-gold" strokeWidth={1.4} />
                </div>
                <h3 className="mt-6 font-display text-lg text-cream">
                  {w.title}
                </h3>
                <p className="mt-3 text-sm text-cream-muted leading-relaxed">
                  {w.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
